import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/avatar.svg'


const _hoisted_1 = { class: "account-modal" }
const _hoisted_2 = { class: "account-modal--title" }
const _hoisted_3 = { class: "account-modal--username" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "account-modal--username-image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_5 = {
  key: 0,
  class: "account-modal--username-info"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "username", -1)
const _hoisted_7 = { class: "account-modal--username-info-name" }
const _hoisted_8 = { class: "account-modal--username-info-email" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "account-modal--links"
}

import BottomModal from '@/components/BottomModal.vue'
import { useUser } from '@/store/user'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountInfoModal',
  props: {
    show: { type: Boolean }
  },
  emits: ["close", "show:faq"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
  (e: 'show:faq'): void;
}), expose: any, slots: any, attrs: any }) {





const router = useRouter()
const { user, logoutUser, isDriver, isAdmin } = useUser()

const onLogout = async () => {
  emit('close')
  await router.push({ name: 'login' })
  logoutUser()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BottomModal, {
    size: "sm",
    show: __props.show,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(" Account Info "),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('close')), ["prevent"]))
          }, "Close")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_unref(user))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(user).fullName), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(user).email), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            href: "#",
            class: "account-modal--username-logout",
            onClick: _withModifiers(onLogout, ["prevent"])
          }, "Logout", 8, _hoisted_9)
        ]),
        (_unref(isDriver) || _unref(isAdmin))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('show:faq')), ["prevent"]))
                  }, "Troubleshooting")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})